import { AppInfoType } from "../types/types";

const useApi = {
  getRequirements(): Promise<AppInfoType[]> {
    //console.debug("getting requirements from api");

    return fetch(
      "https://mobileupdate.infominds.eu/api/PublicFiles?requestedFileName=requirements.json",
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((result: AppInfoType[]) => {
        //console.debug("api result:", result);
        return result;
      });
  },
};

export default useApi;
